import React, { Component } from "react";
import Grid from '@material-ui/core/Grid';
import ReactPaginate from 'react-paginate';
import Hidden from '@material-ui/core/Hidden';
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import MobileVideoCards from "/components/Video/MobileVideoCards";
import Pagination from "/components/Search/Pagination";
import Loading from "/components/Search/Loading";
import ResultItems from "/components/resultItems";

class SearchItems extends Component {
  render() {
    const { loading, type, dateOrRelevanceItems, lastPage, page, query } = this.props;
    return (
        <div>
            {/* {loading ? 
                <Loading />
            : */}
           { type == 'videos' ?
                <React.Fragment>
                <Hidden only={['lg', 'xl']}>
                    <MobileVideoCards items={dateOrRelevanceItems} color='#000' newsItems={null} />
                </Hidden>
                <Hidden only={['sm', 'xs', 'md']}>
                    <DesktopVideoCards items={dateOrRelevanceItems} color='#000' newsItems={null} /> 
                </Hidden>
                </React.Fragment>
            :
            <React.Fragment>
                {type == 'articles' ?
                dateOrRelevanceItems.map((item, index) => {
                    return (
                        <ResultItems item={item} key={index}/>
                    )}
                )
                : null
                }
            </React.Fragment>
            }
            {/* {loading ? 
            <Loading />
                : */}
                <Pagination lastPage={lastPage} page={page} query={query} />
            {/* } */}
            
        </div>
        )
    }
}

export default SearchItems;
